import React from 'react';
import { type ListenerProps, FabricChannel } from '../types';
import processEvent from './process-event';
import GenericAnalyticsListener from '../GenericAnalyticsListener';

export default function AtlaskitListener(props: ListenerProps): React.JSX.Element {
	return (
		<GenericAnalyticsListener
			{...props}
			channel={FabricChannel.atlaskit}
			processEvent={processEvent}
		/>
	);
}
